import { useCallback, useRef } from 'react';

import type { OnResize } from 'components/WithResize/types';

const useGridTablesResizeObserver = (cssVariableName: string) => {
    const containerRef = useRef<HTMLDivElement>(null);

    const handleResize: OnResize = useCallback(
        (gridTemplateColumns: string) => {
            if (containerRef.current) {
                containerRef.current.style.setProperty(cssVariableName, gridTemplateColumns);
            }
        },
        [cssVariableName]
    );

    return { containerRef, handleResize };
};

export default useGridTablesResizeObserver;
